import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/mixins/Animatable.ts
function Animatable(baseClass) {
  class AnimatableMixin extends baseClass {
    constructor() {
      super(...arguments);
      this.contentDuration = 300;
      this.contentKeyframes = [{ opacity: 0 }, { opacity: 1 }];
      this.contentStagger = 150;
      this.preInitChildren = false;
      this.preventZOrder = false;
      this.wrapperDuration = 350;
      this.wrapperKeyframes = [
        { transform: "translateY(-100%)" },
        { transform: "translateY(0%)" }
      ];
    }
    updated(_changedProperties) {
      super.updated(_changedProperties);
      if (_changedProperties.has("contentChildren") && this.preInitChildren) {
        this._preinitChildren();
      }
    }
    async animateContent(hide = false) {
      if (!this._animateChildren) return false;
      return new Promise((resolve) => {
        for (let index = 0; index < this._animateChildren.length; index += 1) {
          const contentIndex = hide ? this._animateChildren.length - index - 1 : index;
          if (typeof this._animateChildren[contentIndex] !== "undefined") {
            const anim = this._animateChildren[contentIndex].animate(this.contentKeyframes, {
              duration: this.contentDuration,
              iterations: 1,
              direction: hide ? "reverse" : "normal",
              delay: this.contentStagger * index,
              fill: "both"
            });
            if (!this.preventZOrder) {
              this._animateChildren[contentIndex].style.zIndex = (this._animateChildren.length - index - 1).toString();
            }
            if (index === this._animateChildren.length - 1) {
              anim.onfinish = () => {
                this.dispatchEvent(new Event(hide ? "jb-reveal:contentHidden" : "jb-reveal:contentRevealed"));
                resolve(true);
              };
            }
          }
        }
      });
    }
    async animateWrapper(hide = false) {
      await customElements.whenDefined("jb-modal");
      const animatedElement = this._parentOverlay ? this._parentOverlay.shadowRoot.querySelector("dialog") : this._wrapperElement;
      const anim = animatedElement?.animate(this.wrapperKeyframes, {
        duration: this.wrapperDuration,
        iterations: 1,
        direction: hide ? "reverse" : "normal",
        fill: "both"
      });
      return new Promise((resolve) => {
        if (anim) {
          anim.onfinish = () => {
            this.dispatchEvent(new Event(hide ? "jb-reveal:wrapperHidden" : "jb-reveal:wrapperRevealed"));
            resolve(true);
          };
        } else {
          resolve(false);
        }
      });
    }
    async animateWrapperControls(hide = false) {
      const wrapperControls = [];
      if (this._parentOverlay) {
        wrapperControls.push(this._parentOverlay.shadowRoot.querySelector(".header-left"));
        wrapperControls.push(this._parentOverlay.shadowRoot.querySelector(".modal__close-btn"));
        if (this._parentOverlay.hasLogo) {
          wrapperControls.push(this._parentOverlay.shadowRoot.querySelector(".modal__logo-wrap"));
        }
      }
      return new Promise((resolve) => {
        for (let index = 0; index < wrapperControls.length; index += 1) {
          const contentIndex = hide ? wrapperControls.length - index - 1 : index;
          if (typeof wrapperControls[contentIndex] === "undefined") {
            continue;
          }
          const anim = wrapperControls[contentIndex].animate(this.contentKeyframes, {
            duration: this.contentDuration,
            iterations: 1,
            direction: hide ? "reverse" : "normal",
            fill: "both"
          });
          if (index !== wrapperControls.length - 1) {
            continue;
          }
          anim.onfinish = () => {
            this.dispatchEvent(
              new Event(hide ? "jb-reveal:wrapperControlsHidden" : "jb-reveal:wrapperControlsRevealed")
            );
            resolve(true);
          };
        }
      });
    }
    async hide() {
      await this.animateContent(true);
      if (this._parentOverlay) {
        await this.animateWrapperControls(true);
      }
      await this.animateWrapper(true);
    }
    async reveal() {
      await this.animateWrapper();
      if (this._parentOverlay) {
        await this.animateWrapperControls();
      }
      await this.animateContent();
    }
    get _animateChildren() {
      return this.contentChildren ?? this.shadowRoot?.querySelector("slot")?.assignedElements({ flatten: true });
    }
    get _parentOverlay() {
      if (this.parentElement && this.parentElement.tagName === "JB-MODAL") return this.parentElement;
      if (this.parentElement.parentElement && this.parentElement.parentElement.tagName === "JB-MODAL")
        return this.parentElement.parentElement;
      return false;
    }
    _preinitChildren() {
      if (this.contentChildren?.length === 0) return;
      const kf = this.contentKeyframes[0];
      this.contentChildren.forEach((child) => {
        const element = child;
        Object.keys(kf).forEach((key) => {
          element.style[key] = kf[key];
        });
      });
    }
    get _wrapperElement() {
      return this;
    }
  }
  __decorateClass([
    n({ type: Array })
  ], AnimatableMixin.prototype, "contentChildren", 2);
  __decorateClass([
    n({ type: Number })
  ], AnimatableMixin.prototype, "contentDuration", 2);
  __decorateClass([
    n({ type: Object })
  ], AnimatableMixin.prototype, "contentKeyframes", 2);
  __decorateClass([
    n({ type: Number })
  ], AnimatableMixin.prototype, "contentStagger", 2);
  __decorateClass([
    n({ type: Boolean })
  ], AnimatableMixin.prototype, "preInitChildren", 2);
  __decorateClass([
    n({ type: Boolean })
  ], AnimatableMixin.prototype, "preventZOrder", 2);
  __decorateClass([
    n({ type: Number })
  ], AnimatableMixin.prototype, "wrapperDuration", 2);
  __decorateClass([
    n({ type: Object })
  ], AnimatableMixin.prototype, "wrapperKeyframes", 2);
  return AnimatableMixin;
}

export {
  Animatable
};
